import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"icon-right\">\r\n  <path d=\"M164.64,139.348 L80.634,55.346 L91.946,44.032 L175.95,128.034 L164.64,139.348 Z M176.022,128.05 L91.03,213.04 L79.716,201.728 L164.71,116.734 L176.022,128.05 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol